<script lang="ts" setup>
const props = defineProps<{ list?: { label?: string, link?: string }[] }>()

const list = computed(() => {
  return [{ label: 'Home', link: '/' }, ...(props.list ?? [])]
})
</script>

<template>
  <ADevice>
    <template #h5>
      <!-- <MContainer>
        <div class="flex pt-[72px] justify-end">
          <div v-for="(item, idx) in list" :key="idx" class="flex">
            <ALink v-if="item.link" :to="item.link"
              class="!text-black/85 text-[12px] leading-[20px] max-w-[160px] line-clamp-1">{{
                item.label }} /
            </ALink>
            <span v-else class="text-black/45 text-[14px] max-w-[160px] line-clamp-1">{{ item.label }}</span>
          </div>
        </div>
      </MContainer> -->
    </template>
    <template #pc>
      <AContainer>
        <div class="flex pt-[72px] justify-end">
          <div v-for="(item, idx) in list" :key="idx" class="flex">
            <ALink v-if="item.link" :to="item.link"
              class="!text-black/85 text-[12px] leading-[20px] max-w-[160px] line-clamp-1">{{
                item.label }} 
            </ALink>
            <span class="mx-[8px] text-[12px]" v-if="item.link">/</span>
            <span v-else class="text-black/45 text-[14px] max-w-[160px] line-clamp-1">{{ item.label }}</span>
          </div>
        </div>
      </AContainer>
    </template>
  </ADevice>
</template>

<style lang="scss" scoped></style>
